export type HelpPage = "about" | "user" | "security" | "privacy" | "tos";

export interface HelpPageMeta {
  page: HelpPage;
  title: string;
  subtitle: string;
}

export const helpPages: HelpPageMeta[] = [
  {
    page: "about",
    title: "Why Nuthatch Family Exists",
    subtitle: "The story behind Nuthatch Family and why your family's data is safe here",
  },
  {
    page: "user",
    title: "User Manual",
    subtitle: "How to use every screen and feature in Nuthatch Family",
  },
  {
    page: "security",
    title: "How Security Works",
    subtitle: "Encryption, data handling, and how Nuthatch Family protects your family's information",
  },
  {
    page: "privacy",
    title: "Privacy Policy",
    subtitle: "What data we collect and how we use it",
  },
  {
    page: "tos",
    title: "Terms of Service",
    subtitle: "Rules and agreements for using Nuthatch Family",
  },
];
